import { API } from "@infra/api";
import { ACTIVE_PASSWORDLESS_MEMBERS_FILTER } from "@infra/api/routers/data/tables/team-members";
import { CachedAPI } from "@infra/cachedApi";
import type { TeamMember } from "@domain/CRM/teamMember";
import type { IMissionControlLogs } from "@ports/missionControl/IMissionControlLogs";
import type { ITeamMembers } from "@ports/teamMembers/ITeamMembers";
import { makeExportEventLogsUseCases, makeMissionControlLogsUseCases } from "@app/missionControl";

const teamMembersApi: ITeamMembers = {
	getById: (id) => API.Data.TeamMembers.get.byId(id) as Promise<TeamMember | undefined>,
	setPassword: (id, password) => API.Data.TeamMembers.setPassword(id, password),
	createOperator: (input) => API.Data.TeamMembers.createOperator(input),
	listActivePasswordless: () => API.Data.TeamMembers.get.byFilter(ACTIVE_PASSWORDLESS_MEMBERS_FILTER),
};

const logsApi: IMissionControlLogs = {
	getLogsInRange: (user, start, end) => CachedAPI.MissionControl.logs.getInRange(user, start, end),
};

/**
 * Bound mission-control use cases — both feed the Admin → Mission Control
 * Logs surfaces. Sub-namespaces match the existing call-site naming:
 *  - `exportEventLogs` for the multi-operator merge/export workflow.
 *  - `logs` for the simpler single-username download.
 */
export const missionControlUseCases = {
	exportEventLogs: makeExportEventLogsUseCases({ teamMembersApi, logsApi }),
	logs: makeMissionControlLogsUseCases({ logsApi }),
};

export type MissionControlUseCases = typeof missionControlUseCases;

export { teamMembersApi };
